
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Slider } from "@/components/ui/slider";
import { Filter } from "lucide-react";

interface VacationFiltersProps {
  countryFilter: string;
  setCountryFilter: (value: string) => void;
  priceFilter: string;
  setPriceFilter: (value: string) => void;
  priceRange: number[];
  setPriceRange: (value: number[]) => void;
  useSlider: boolean;
  setUseSlider: (value: boolean) => void;
  countries: string[];
}

export const VacationFilters = ({
  countryFilter,
  setCountryFilter,
  priceFilter,
  setPriceFilter,
  priceRange,
  setPriceRange,
  useSlider,
  setUseSlider,
  countries
}: VacationFiltersProps) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Filter className="h-4 w-4" />
        <span className="font-medium">Populair:</span>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select value={countryFilter} onValueChange={setCountryFilter}>
          <SelectTrigger>
            <SelectValue placeholder="Alle landen" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Alle landen</SelectItem>
            {countries.map((country) => (
              <SelectItem key={country} value={country}>
                {country}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        
        <Select value={priceFilter} onValueChange={(value) => {
          setPriceFilter(value);
          setUseSlider(value === "custom");
        }}>
          <SelectTrigger>
            <SelectValue placeholder="Alle prijzen" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Alle prijzen</SelectItem>
            <SelectItem value="budget">Budget (tot €300)</SelectItem>
            <SelectItem value="low">Voordelig (€300 - €600)</SelectItem>
            <SelectItem value="medium">Gemiddeld (€600 - €1200)</SelectItem>
            <SelectItem value="high">Duur (€1200 - €2500)</SelectItem>
            <SelectItem value="luxury">Luxe (vanaf €2500)</SelectItem>
            <SelectItem value="custom">Aangepast bereik</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {useSlider && (
        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Prijsbereik: €{priceRange[0]} - €{priceRange[1]}
          </label>
          <Slider
            value={priceRange}
            onValueChange={setPriceRange}
            max={5000}
            min={0}
            step={50}
            className="w-full"
          />
        </div>
      )}
    </div>
  );
};
